module.exports = __webpack_public_path__ + "img/Devil in the Shortwave.9c770355.jpg";